import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

function SearchHelpText() {
  return (
    <Wrapper>
      Please search for a Viewer ID or Public IP Address to view summary of the viewer activity and
      viewer session details.
    </Wrapper>
  );
}

export default SearchHelpText;
